module.exports = __webpack_public_path__ + "static/media/discontrol025.20385368.jpg";